import { Form, Input, InputNumber, Select } from "antd";
import { requiredField } from "../common/common";

export default function DpiTypeFields() {
  return (
    <>
      <Form.Item
        name="name"
        label="Nome"
        rules={[requiredField, { whitespace: true, message: "Campo obbligatorio" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="trackingType" label="Tracciamento" rules={[requiredField]}>
        <Select
          options={[
            { label: "Matricola", value: "SERIAL" },
            { label: "Quantità", value: "QUANTITY" },
          ]}
        />
      </Form.Item>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) =>
          getFieldValue("trackingType") === "SERIAL" && (
            <Form.Item name="inspectionMonths" label="Verifica periodica ogni (Mesi)">
              <InputNumber controls={false} min={1} precision={0} placeholder={"Mesi"} />
            </Form.Item>
          )
        }
      </Form.Item>
    </>
  );
}
